module.exports = __webpack_public_path__ + "static/media/private-notes-icon.eb147b24.svg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/assets/images/private-notes-icon.svg
// module id = 1783
// module chunks = 27